import { Modal } from "react-bootstrap";
import React, { useState, useContext } from "react";
import { AuthContext } from "../../AuthProvider";
import { ScreenContext } from "../../ScreenProvider";
import Parse from "parse";
import './PeakLengthSetting.css';

const PeakLengthSetting = () => {

    const { esp, updateUserEsp, setUserEsp } = useContext(AuthContext);
    const { isMobile } = useContext(ScreenContext);
    const [modalIsOpen, setModalIsOpen] = useState(false);

    const handleOpenModal = () => {
        setModalIsOpen(true);
    };

    const handleCloseModal = () => {
        setModalIsOpen(false);
    };

    const update = async (espId, updates) => {
        await updateUserEsp(espId, updates);
    }

    const handleInput = (change) => {
        const newValue = (esp?.heating?.peakLengthSetting || 12) + change;
        if (newValue > 3 && newValue < 25) {
            update(esp.id, { heating: { peakLengthSetting: newValue } }).then((result) => {
                Parse.Cloud.run("updateHeatingSchedule", { espId: esp.id })
                    .then((scheduleResult) => {
                        setUserEsp(scheduleResult);
                    });
            });
        }
    };
    return (
        <div>
            <div>
                <button onClick={handleOpenModal} className="controlpanel-button">
                    <i className="bi bi-bar-chart-fill controlpanel-button-peak-icon" style={{ color: "#D0D0D0", position: 'absolute', top: '-10%' }} />
                    <span className="controlpanel-button-peak-number" style={{ position: 'absolute', top: '5%' }}>{esp?.heating?.peakLengthSetting}</span>
                    <span className="controlpanel-button-peak-text" style={{ position: 'absolute', bottom: '0%' }}>Piklängd</span>
                </button>
            </div>
            <Modal show={modalIsOpen} onHide={handleCloseModal} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Temperaturinställningar</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className={`d-flex mb-3 ${isMobile ? "flex-column" : "flex-row align-items-center"}`}>
                        <div className={`d-flex ${isMobile ? "flex-row" : "flex-column"} align-items-center pe-3`}>
                            <div style={isMobile ? { width: '70px' } : {}}>
                                <strong>Maxlängd</strong>
                            </div>
                            <div className="d-flex align-items-center" style={{ width: '120px' }}>
                                <i className="bi bi-dash ms-2" onClick={() => handleInput(-1)} style={{ cursor: 'pointer', color: '#007bff' }} />
                                <span className="mx-2">{esp?.heating?.peakLengthSetting || 12}</span>
                                <i className="bi bi-plus" onClick={() => handleInput(1)} style={{ cursor: 'pointer', color: '#ff4d4d' }} />
                            </div>
                        </div>
                    </div>

                    Ställ in hur många kvartar som mest i rad du vill använda min- eller max-temperaturen. Längre perioder gör att temperaturen svänger mer vilket är mest kännbart i hus med sämre isolering.
                </Modal.Body>
            </Modal>
        </div >

    )
}

export default PeakLengthSetting;


